var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topnav"},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"rounded-xl mb-2"},[_vm._l((_vm.posts),function(item,index){return _c('Post',{key:'item-' + index,attrs:{"item":item}})}),(!_vm.posts.length && _vm.ChannelList.length > 0)?_c('NoMorePosts',{attrs:{"text":_vm.noResultText}}):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }